import Paragraph from '@editorjs/paragraph';
import type { ToolboxConfig } from '@editorjs/editorjs';

import { PARAGRAPH_SANITIZE } from '../sanitize-config';

// Exception tool: thin subclass of EditorJS's Paragraph used for content the
// editor wants tagged as an exception (warning / caveat). Only the toolbox
// metadata differs from the base Paragraph; the persistent leaf style
// ('exception') is recovered by the cluster's save adapter from block.type.
export class ExceptionTool extends Paragraph {
  static get pasteConfig(): false {
    return false;
  }

  static get sanitize() {
    return PARAGRAPH_SANITIZE;
  }

  // Enter inserts a line break within the block instead of splitting into a
  // new block — new blocks are only created via the Add-block menu.
  static get enableLineBreaks(): boolean {
    return true;
  }

  static get toolbox(): ToolboxConfig {
    return {
      title: 'Exception',
      icon:
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +
        '<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>' +
        '<line x1="12" y1="9" x2="12" y2="13"/>' +
        '<line x1="12" y1="17" x2="12.01" y2="17"/>' +
        '</svg>',
    };
  }
}
